<ap-popover
    [hideOnBlur]="true"
    [position]="lastItem() ? 'right' : 'left'"
    (isOpenChanged)="onIsOpenChanged($event)"
    data-testid="header-horizontal-menu-popover"
>
    <span ap-popover-parent>
        @if (!!navigationItem().ariaLabel) {
            <span class="ap-sr-only">
                {{ navigationItem().ariaLabel }}
            </span>
        }
        <span class="ap-header__navigation--popover-wrap" aria-hidden="true">
            @if (navigationItem().type === navigationType.PARENT) {
                {{ navigationItem().label }}
            }
            @if (navigationItem().type === navigationType.PARENT_ICON) {
                <ap-icon [name]="navigationItem().iconName" size="large" data-testid="header-horizontal-menu-icon"></ap-icon>
            }
            @if (navigationItem().badge) {
                <asn-badge
                    [ngClass]="{
                        'ap-header__navigation-icon-badge': navigationItem().type === navigationType.PARENT_ICON
                    }"
                    data-testid="header-badge"
                    >{{ navigationItem().badge }}</asn-badge
                >
            }
            <ap-icon
                class="ap-header__navigation-chevron--right"
                name="chevron-down-animated"
                color="inherit"
                size="small"
                data-testid="header-horizontal-menu-icon"
            ></ap-icon>
        </span>
    </span>

    <div ap-popover-content class="ap-header__dropdown" aria-haspopup="true">
        <ul role="menu">
            @for (child of navigationItem().children; track child) {
                <li role="menuitem">
                    @if (child.type === navigationType.LINK_SAME_TAB) {
                        <a tabindex="0" [href]="child?.link" [attr.aria-label]="child.ariaLabel" (click)="navigationClicked.emit(child)">
                            {{ child.label }}
                            @if (child.badge) {
                                <asn-badge>{{ child.badge }}</asn-badge>
                            }
                        </a>
                    }
                    @if (child.type === navigationType.LINK_NEW_TAB) {
                        <a
                            tabindex="0"
                            rel="noopener noreferrer"
                            target="_blank"
                            [href]="child?.link"
                            [attr.aria-label]="child.ariaLabel"
                            (click)="navigationClicked.emit(child)"
                        >
                            {{ child.label }}
                            @if (child.badge) {
                                <asn-badge>{{ child.badge }}</asn-badge>
                            }
                            <div class="ap-sr-only">Opent in een nieuw tabblad</div>
                        </a>
                    }
                    @if (child.type === navigationType.BUTTON) {
                        <a
                            tabindex="0"
                            [attr.aria-label]="child.ariaLabel"
                            (click)="navigationClicked.emit(child)"
                            (keyup.enter)="navigationClicked.emit(child)"
                        >
                            {{ child.label }}
                            @if (child.badge) {
                                <asn-badge>{{ child.badge }}</asn-badge>
                            }
                        </a>
                    }
                </li>
            }
        </ul>
    </div>
</ap-popover>
